import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { getNewFilterdProducts } from "../../store/actions/product-actions";
import { SET_FILTER } from "../../store/types";

const MyShopCategory = () => {
  const categories = ["Mobile", "Tablet", "Watch", "Airpod", "Accessories"];
  const dispatch = useDispatch();
  const currentFilters = useSelector((state) => state.products.filter);

  const handleCategoryClick = (category) => {
    // Handle array of categories
    const updatedCategories = currentFilters.category.includes(category)
      ? currentFilters.category.filter((cat) => cat !== category) // Remove if exists
      : [...currentFilters.category, category]; // Add if doesn't exist

    // Update the filter in Redux
    dispatch({
      type: SET_FILTER,
      payload: {
        filterType: "category",
        value: updatedCategories,
      },
    });

    // Fetch filtered products with updated categories
    dispatch(
      getNewFilterdProducts({
        ...currentFilters,
        page: 1,
        limit: 15,
        category: updatedCategories,
      })
    );
  };

  const handleClearCategories = () => {
    dispatch({
      type: SET_FILTER,
      payload: {
        filterType: "category",
        value: [],
      },
    });

    // dispatch(
    //   getNewFilterdProducts({
    //     ...currentFilters,
    //     page: 1,
    //     limit: 15,
    //     category: [],
    //   })
    // );
  };

  return (
    <div style={{ padding: "20px", border: "1px solid #e2e8f0", borderRadius: "8px", backgroundColor: "white" }}>
      <h4 style={{ fontSize: "18px", fontWeight: "600", color: "#2d3748", marginBottom: "16px", paddingBottom: "8px", borderBottom: "1px solid #edf2f7" }}>Categories</h4>
      <div style={{ display: "flex", flexDirection: "column", marginTop: "16px" }}>
        <div style={{ padding: "6px 0" }}>
          <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
            <input
              type="checkbox"
              checked={currentFilters.category.length === 0}
              onChange={handleClearCategories}
              style={{ height: "16px", width: "16px", color: "#4299e1", transition: "all 0.15s ease-in-out" }}
            />
            <span style={{ marginLeft: "8px", color: "#4a5568" }}>All Categories</span>
          </label>
        </div>

        {categories.map((category, index) => (
          <div style={{ padding: "6px 0", marginTop: "8px" }} key={index}>
            <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={currentFilters.category.includes(category)}
                onChange={() => handleCategoryClick(category)}
                style={{ height: "16px", width: "16px", color: "#4299e1", transition: "all 0.15s ease-in-out" }}
              />
              <span style={{ marginLeft: "8px", color: "#4a5568" }}>{category}</span>
            </label>
          </div>
        ))}
      </div>
    </div>

  );
};

export default MyShopCategory;
